var ElementBase = require("../elementBase");
var Retriever = require("../retriever");
require("../results-table");
require("./standard-primary.less");
var { mapToElements, toggleAttribute } = require("../utils");

var strings = require("strings.sheet.json");

class StandardPrimary extends ElementBase {
  constructor() {
    super();
    this.fetch = new Retriever(this.load);
  }

  static get boundMethods() {
    return ["load"];
  }

  static get observedAttributes() {
    return ["src", "href", "live", "party"];
  }

  static get mirroredProps() {
    return ["src", "href"]
  }

  attributeChangedCallback(attr, old, value) {
    switch (attr) {
      case "src":
        if (this.hasAttribute("live")) {
          this.fetch.watch(value, this.getAttribute("live") || 15);
        } else {
          this.fetch.once(value);
        }
        break;

      case "live":
        if (typeof value == "string") {
          this.fetch.start(value || 15);
        } else {
          this.fetch.stop();
        }
        break;

      default:
        this.render();
    }
  }

  load(data) {
    this.cache = data;
    this.render();
  }

  render() {
    var elements = this.illuminate();

    if (!this.cache) return;
    var { races, chatter, footnote, general } = this.cache;
    
    var partyDisplayOrder = ["GOP","Dem"]

    function sortParty(parties,displayOrder) {
      const orderIndexes = displayOrder.slice(0).reverse();
      return parties.sort((a,b) => {
        var aI = -orderIndexes.indexOf(a.party)
        var bI = -orderIndexes.indexOf(b.party)
        return aI - bI
      })
    }
    sortParty(races,partyDisplayOrder)
    
    elements.chatter.innerHTML = chatter || "";
    elements.footnote.innerHTML = footnote || "";

    var party = this.getAttribute("party");
    if (party == "undefined") party = null;

    var races = mapToElements(elements.results, this.cache.races);
    races.forEach(([race, element]) => {
      element.className = "race";

      // carry over footnote if needed
      if (typeof(race.footnote) != "undefined") {
        race.results[0].footnote = race.footnote;
      }

      toggleAttribute(element, "hidden", party && race.party != party);
      // create result tables
      var pairs = mapToElements(element, race.results, "results-table");

      // render each one
      var test = !!this.cache.test;
      pairs.forEach(([data, child]) => {

        var href = this.getAttribute("href");
        var max = this.getAttribute("max");
        var host = this.getAttribute("host");

        if (max) child.setAttribute("max", max);

        var readableParty = general ? "" : 
          data.party == "Dem" ? "Democratic" : data.party == "GOP" ? "Republican" : data.party || "Open";
        var readableOffice = strings[race.office];
        var typeCode = "";
        if (this.cache.general) typeCode += "G";
        if (this.cache.runoff) typeCode += "R";
        if (this.cache.special) typeCode += "S";
        var readableType = strings[`race-${typeCode}`];
        var apState = strings[race.state + "-AP"]
        var headline = `${apState} ${general ? `${readableType}` : `${readableParty} primary`}`;

        if (host == "statepage") {
          child.setAttribute("max", 99);
          headline = `${readableParty} primary`;
          if (href != "false") {
            var search = new URLSearchParams("counties=true");
            search.set("date", race.date);
            search.set("party", race.party || "");
            search.set("office", race.office)
            if (this.cache.special) {
              search.set("special", true)
            }
            href = "#" + search.toString();

            var { resultsLink } = child.illuminate();
            resultsLink.innerHTML = "See county results &rsaquo;";
          }
        }

        if (href && href != "false") child.setAttribute("href", href);
        toggleAttribute(child, "test", test);

        child.setAttribute("headline", headline);
        child.render(data);
      });
    });
  }

  static get template() {
    return `
<div class="chatter" data-as="chatter"></div>
<div class="results" data-as="results"></div>
<p class="footnote" data-as="footnote"></p>
    `;
  }
}

StandardPrimary.define("standard-primary");
